import { useCallback } from 'react';
import posthog from 'posthog-js';

export const useAnalytics = () => {
  const trackEvent = useCallback((eventName: string, properties?: Record<string, unknown>) => {
    try {
      // Add common properties to all events
      const commonProps = {
        timestamp: new Date().toISOString(),
        url: window.location.href,
        referrer: document.referrer,
        viewport: {
          width: window.innerWidth,
          height: window.innerHeight,
        },
      };

      posthog.capture(eventName, {
        ...commonProps,
        ...properties,
      });
    } catch (error) {
      console.error('Error tracking event:', error);
    }
  }, []);

  const identifyUser = useCallback((userId: string, properties?: Record<string, unknown>) => {
    try {
      posthog.identify(userId, properties);
    } catch (error) {
      console.error('Error identifying user:', error);
    }
  }, []);

  const resetAnalytics = useCallback(() => {
    try {
      posthog.reset();
    } catch (error) {
      console.error('Error resetting analytics:', error);
    }
  }, []);

  return {
    trackEvent,
    identifyUser,
    resetAnalytics,
  };
};
